import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { DeclineBdcRequestDialogComponent } from './decline-bdc-request-dialog.component'

@Injectable({ providedIn: 'root' })
export class DeclineBdcRequestDialogService {
  constructor(private dialog: MatDialog) {}

  open(inquiry: Inquiry) {
    const config: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data: { inquiry },
    }

    return this.dialog.open(DeclineBdcRequestDialogComponent, config)
  }
}
